var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93329 17.4C10.4533 16.88 10.4533 16.04 9.93329 15.52L4.77329 10.3333H25C25.7333 10.3333 26.3333 9.73333 26.3333 8.99999C26.3333 8.26666 25.7333 7.66666 25 7.66666H4.77329L9.94663 2.49333C10.4666 1.97333 10.4666 1.13333 9.94663 0.613328C9.42663 0.0933276 8.58663 0.0933276 8.06663 0.613328L0.599961 8.06666C0.0799609 8.58666 0.0799609 9.42666 0.599961 9.94666L8.05329 17.4C8.57329 17.9067 9.42663 17.9067 9.93329 17.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.91ae3b1878c3a5e68d420cdd83000bff.svg";
export { ForwardRef as ReactComponent };